jQuery(function () {
    var puffToggleBtn = $('.demo-account-puff__mobile-footer__button');
    var puffContent = $('.demo-account-puff__content');
    puffToggleBtn.on('click', function () {
        if (puffToggleBtn.hasClass('read-more')) {
            puffToggleBtn.removeClass('read-more').addClass('read-less');
            puffToggleBtn.text('Dölj');
            puffContent.removeClass('mobile-hidden');
        }
        else if (puffToggleBtn.hasClass('read-less')) {
            puffToggleBtn.removeClass('read-less').addClass('read-more');
            puffToggleBtn.text('Läs mer');
            puffContent.addClass('mobile-hidden');
        }
    });
});
